$(document).ready(function () {
  if($('.owl-product-related').length){
    $('.owl-product-related').owlCarousel({
          loop:false,
          margin:10,
          dots:false,
          nav:false,
          responsive:{
              0:{
                  items:1,
                  stagePadding: 45
              },
              600:{
                  items:2,
                  stagePadding: 45
              },
              1024:{
                  items:5
              }
          }
      })
  }
  $('.product-form__input.select select').change(function(){
    var index = $(this).find('option:selected').index();
    console.log(index);
    if(index == 0){
      $('.template-product .product__info-container .product-form__submit').attr('disabled',true);
    }else{
      $('.template-product .product__info-container .product-form__submit').removeAttr('disabled');
    }
    if(index != 0 ){
      index = index - 1;
    }
    $('.product-form__input.size input[type=radio]').eq(index).trigger('click');
  });
  
  function check_select_option () {
    var index_option = $('.product-form__input.select select option:selected').index();
    if(index_option == 0){
      $('.template-product .product__info-container .product-form__submit').attr('disabled',true);
    }else{
      $('.template-product .product__info-container .product-form__submit').removeAttr('disabled');
    }
  }
  setInterval(check_select_option,300);
  
  function changeHeightCard() {
    var el_val = $('.product-recommendations .card-information__wrapper-content').attr('style');
    if(el_val){
      clearInterval(changeHeightCard);
    }else{
      $('.product-recommendations .card-information__wrapper-content').matchHeight();
    }
  }
  setInterval(changeHeightCard,300);
  var index_select = $(".product__info-container .product-form__input.select select option:selected").index();
  if(index_select == 0){
    $('.template-product .product__info-container .product-form__submit').attr('disabled',true);
  }
   $('.template-product .product__info-container .product-form__submit').click(function(e){
     var index = $(".product__info-container .product-form__input.select select option:selected").index();
     if(index == 0)
      {
        e.preventDefault();
        $(".product__info-container .product-form__input.select select").addClass('error');
      }else{
        $(".product__info-container .product-form__input.select select").removeClass('error');
      }
   })
})